import React from 'react'
import './NotFound.css'

function NotFound() {
  return (
    <div className="home container">
    <div className="NotFound-div">
      <h1 className="NotFound-banner">404 NOT FOUND</h1>
      <h4>
        Sorry, there is no content here. Please use the navaigation above to get to where you were going.
      </h4>

      <h5>
        While you are here, you may want to check out the <a href="https://azureinnovationstation.com/community">Azure Innovation Station Community!</a>
      </h5>

    </div>
  </div>
  )
}

export default NotFound
